<template>
    <div class="UsedLibrariesInBomComponent DataTables">

        <div v-show="isData" :id="id"></div>
        <!-- <ContextMenuComponent :menu="menu" :id="id"></ContextMenuComponent> -->
        <LoaderComponent  v-show="!isData"></LoaderComponent>
        <!-- <span v-show="!isData">{{ lang.NoContent }}</span> -->

    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
//import ContextMenuComponent from "@/components/shared/ContextMenuComponent";
var $ = require('jquery');
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
    name: 'UsedLibrariesInBomComponent',
    props: {
        lang: Object,
        tabIndex: Number
    },
    components: {
        LoaderComponent,
        //ContextMenuComponent

    },
    data() {
        return {
            mainTable: "",
            id: "UsedLibrariesInBomComponent",
            columns: [],
            colsAssign: [],
            libraries: [],
            isData: false,
            contextMenu: {},
            //list of items in the context menu
            menu: [
                //{id: "Details", text: this.lang.contextmenu_text_Details},

            ],

        }
    },
    computed: {
        lastRevisionHistory() {
            if (this.$store.getters.revisionHistory == null) {
                return
            }
            let tab = this.$store.getters.revisionHistory;
            let obj = tab[0];
            for (let i = 0, lei = tab.length; i < lei; i++) {

                if (tab[i].revision > obj.revision) {
                    obj = tab[i];
                }
            }

            return obj;
        },
        revisionId() {
            if (this.lastRevisionHistory == undefined) {
                return
            }
            return this.lastRevisionHistory.id;
            // if (this.$store.getters.selectedRows[0] != undefined){
            //   return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
            // }
            // return ""

        },
        projectId() {
            if (this.lastRevisionHistory == undefined) {
                return
            }
            return this.lastRevisionHistory.projectId;
            // if (this.$store.getters.selectedRows[0] != undefined){
            //   return this.$store.getters.selectedRows[0].col___revisionId.projectId;
            // }
            // return ""
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        },
        bomId() {
            return this.$route.query.bomId;
        }



    },
    created() {

        this.createPartsTable();


    },
    watch: {
        tabIndex: function () {
            if (this.mainTable != "") {
                this.mainTable.rows().deselect();
            }
        },

        reloadedAfterActionComplex: {
            handler: function (newValue) {
                
                for (let el in newValue) {
                    if (newValue[el].name == this.id) {
                        if (newValue[el].status == true) {

                            this.createPartsTable();

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },
        bomId: function () {

            
            this.createPartsTable();

        }
    },
    
    methods: {
        createPartsTable() {
            this.isData = false;
            let vue = this;

            const obj = {
                bomId: this.$route.query.bomId//this.$store.getters.selectedBomRow[0].bomId
            }


            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getUsedLibraries", obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                        if (result.data != null) {
                            
                            vue.prepareData(result.data);
                            vue.isData = true;

                            //vue.$parent.$parent.$parent.isBom = true;
                        }

                    } else {
                        vue.isData = false;
                    }


                })
        },
        prepareData(data) {

            let libraries = [];
            let listOfLibTemp = [];
            for (let i = 0, lei = data.length; i < lei; i++){

                if (!listOfLibTemp.includes(data[i].revisionId)) {
                    
                    if (data[i].partReference != null) {
                        listOfLibTemp[data[i].revisionId] = []
                    }
                   
                } 

            }
            
            for (let j = 0, lej = data.length; j < lej; j++) {
                
                if (listOfLibTemp[data[j].revisionId] != undefined) {
                    listOfLibTemp[data[j].revisionId].push(data[j])
                }    
                

            }

            for (let item in listOfLibTemp) {
                
                let obj = {};
                obj.partNumber = [];
                obj.partReference = [];
                
                for (let j = 0, lej = listOfLibTemp[item].length; j < lej; j++) {
                    
                    if (listOfLibTemp[item][j].partReference != null) {
                        obj.revisionId = listOfLibTemp[item][j].revisionId;
                        obj.libraryId = listOfLibTemp[item][j].libraryId;
                        obj.name = listOfLibTemp[item][j].name;
                        obj.revision = listOfLibTemp[item][j].revision;
                        obj.status = listOfLibTemp[item][j].status;
                        obj.type = listOfLibTemp[item][j].type;
                        obj.partReference = listOfLibTemp[item][j].partReference

                        // obj.partNumber.push(listOfLibTemp[item][j].partNumber)
                        // obj.partReference.push(listOfLibTemp[item][j].partReference)
                    } 
                    
                    
                }
                libraries.push(obj)
                
            }

                        

            
            this.libraries = libraries;
            this.buildColumns();
        },
        buildColumns() {

            this.columns = [
                {
                    name: "Id",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Revision,
                    alignInColumn: "left",
                    type: "taxt"
                },
                {
                    name: this.lang.table_header_Type,
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Status,
                    alignInColumn: "left",
                    type: "text"
                },
                // {
                //     name: this.lang.table_header_PartNumber,
                //     alignInColumn: "left",
                //     type: "text"
                // },
                // {
                //     name: this.lang.table_header_PartNumber,
                //     alignInColumn: "left",
                //     type: "text"
                // },
            ]

            this.colsAssign = [
                { "data": "revisionId" },
                { "data": "name" },
                { "data": "revision" },
                { "data": "type" },
                { "data": "status" },
                // { "data": "partNumber" },
                // { "data": "partReference" },

            ]

            this.buildTable();
        },
        buildTable() {
            

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");

            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
                return;
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "place" + this._uid);
            table.setAttribute("style", "width:100%");
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var _vue = this;


            let columnDefs = [];
            var len = this.columns.length;
            for (var i = 0; i < len; i++) {

                var el = {};

                var classname = '_dt-body-' + this.columns[i].alignInColumn;

                let searchable = true;
                if (i == 0) {
                    searchable = false;
                }

                el = {
                    targets: i,
                    searchable: searchable,
                    className: classname,

                    render: function ( data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }
                        
                        if (meta.col == 4) {
                            if (data == undefined) {
                                return ""
                            }
                            
                            let variant = Tools.getStatusColor(data);
                            
                            return "<b-badge class='badge badge-"+variant+" '>" + data + "</b-badge>";
                            
                            
                        }

                        return data;
                    }


                }

                columnDefs.push(el);


                var th = document.createElement("th");
                tr.appendChild(th);
                var br = document.createElement("br");
                th.appendChild(br);

                var tx = document.createTextNode(this.columns[i].name)
                th.appendChild(tx);

            }


            var option = {};
            option.paging = true;
            option.info = true;
            option.dom = '<fBl<t>ip>';
            option.data = this.libraries;
            option.myColumnFormats = this.columns;
            option.select = true;
            option.order = [[1, "asc"]];
            option.lengthMenu = [[25, 50, -1], [25, 50, "All"]];
            option.columns = this.colsAssign;

            option.columnDefs = columnDefs;
            option.initComplete = function () {



            }
            option.fnDrawCallback = function (oSettings) {

                //_vue.buildContextMenu();
            }
            option.buttons = [
                {
                    extend: 'copy',
                    className: 'btn-' + _vue.variant,
                    exportOptions: {
                        columns: ':visible'
                    }
                },
                {
                    extend: 'print',
                    className: 'btn-' + _vue.variant,
                    messageTop: function () {
                        return _vue.lang.export_label_top + ": " + _vue.$store.getters.selectedProjectRow.name + ", " + _vue.lang.export_label_top2 + ": " + _vue.$store.getters.selectedProjectRow.revision;
                    },
                    exportOptions: {
                        columns: ':visible'
                    },
                    autoPrint: true,
                    style: 'fullWidth',

                    customize: function (win) {
                        $(win.document.body)
                            .css('font-size', '10pt')


                        $(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                },
                {
                    extend: 'csv',
                    className: 'btn-' + _vue.variant,
                    exportOptions: {
                        columns: ':visible'
                    },
                },
                {
                    extend: 'excel',
                    exportOptions: {
                        columns: ':visible'
                    },
                    className: 'btn-' + _vue.variant,
                    customize: function (xlsx) {

                        var sheet = xlsx.xl.worksheets['PM_BOM.xml'];


                    }
                },
                {
                    extend: 'pdfHtml5',
                    messageTop: function () {
                        return _vue.lang.export_label_top + ": " + _vue.$store.getters.selectedProjectRow.name + ", " + _vue.lang.export_label_top2 + ": " + _vue.$store.getters.selectedProjectRow.revision;
                    },
                    className: 'btn-' + _vue.variant,
                    exportOptions: {
                        columns: ':visible'
                    },
                    orientation: 'landscape',
                    pageSize: 'A4',
                    download: 'open',

                    styles: {
                        fullWidth: {
                            fontSize: 3,
                            bold: true,
                            alignment: 'right',
                            margin: [0, 1900, 0, 80]
                        },
                        subheader: {
                            fontSize: 4
                        },
                        superMargin: {
                            margin: [20, 0, 40, 0],
                            fontSize: 5,
                        }
                    },
                    customize: function (doc) {


                        doc.pageMargins = [10, 10, 10, 10];

                        doc.styles.title.fontSize = 9;
                        doc.defaultStyle.fontSize = 7;
                        doc.styles.tableHeader.fontSize = 9;
                        doc.content[0].text = doc.content[0].text.trim();

                        let numberOfHeaders = columnDefs.length;

                        if ((numberOfHeaders > 10) && (numberOfHeaders < 15)) {

                            doc.defaultStyle.fontSize = 5;
                            doc.styles.tableHeader.fontSize = 7;
                        } else if ((numberOfHeaders >= 15) && (numberOfHeaders < 18)) {

                            doc.defaultStyle.fontSize = 5;
                            doc.styles.tableHeader.fontSize = 7;
                        } else if (numberOfHeaders >= 18) {

                            doc.defaultStyle.fontSize = 3;
                            doc.styles.tableHeader.fontSize = 5;
                        }

                    },

                },
                {
                    text: 'Json',
                    exportOptions: {
                        columns: ':visible'
                    },
                    className: 'btn-' + _vue.variant,
                    action: function (e, dt, button, config) {
                        var data = dt.buttons.exportData();

                        $.fn.dataTable.fileSave(
                            new Blob([JSON.stringify(data)]),
                            'Parts.json'
                        );
                    }
                },
                {
                    extend: 'colvis',
                    className: 'btn-' + _vue.variant,

                },
            ];



            if ($.fn.dataTable.isDataTable("#place" + this._uid)) {
                this.mainTable.destroy();
                
            }

            var _vue = this;

            this.mainTable = $('#place' + this._uid).DataTable(option);

            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column(0).visible(false);

            let _mainTable = this.mainTable;

            this.mainTable
                .on('select', function (e, dt, type, indexes) {

                    var rowData = _mainTable.rows(indexes).data();
                    
                    
                    
                    let o = rowData[0];
                    o.libraries = true;
                    //o.partReference = rowData[0].partReference[0];

                                        
                    _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", o)

                })
                .on('deselect', function (e, dt, type, indexes) {
                   
                    _vue.$store.dispatch("unselectAlternative");
                    _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
                })

            $('#place' + this._uid + " tbody").on('dblclick', 'tr', function () {


                let rowData = _mainTable.rows(this._DT_RowIndex).data();

                _vue.goTo(rowData[0]);

            });

            //search input change view
            var searchplace = document.getElementById("place" + this._uid + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

            let lengthplace = document.getElementById("place" + this._uid + "_length").firstChild;
            lengthplace.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
        },
        goTo(goalObj) {
          

            
            let from = "/ProjectManager/ProjectBom";

            let to = "/LibraryManager/LibraryDetails";
            let elementRevisionId = goalObj.revisionId;
            let id = goalObj.libraryId;
            let obj = {
                col___revisionId: {
                    revisionId: goalObj.revisionId,
                    libraryId: goalObj.libraryId
                },
                col___revision: {
                    revisionId: goalObj.revisionId,
                    libraryId: goalObj.libraryId
                },
                col___status: {
                    revisionId: goalObj.revisionId,
                    libraryId: goalObj.libraryId

                },
                col___libraryType: {
                    revisionId: goalObj.revisionId,
                    libraryId: goalObj.libraryId,
                    value: {
                        display: goalObj.type
                    }
                },
                col___name: {
                    revisionId: goalObj.revisionId,
                    libraryId: goalObj.libraryId,
                    value: {
                        display: goalObj.libraryNumber
                    }

                },
            }



            this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedBomRow");
            //this.$store.dispatch("deleteAllSelectedRows");
            this.$store.dispatch("setOneSelectedRows", [obj]);

            this.$store.dispatch("setOuterData", true);

            this.$store.dispatch("editPropertiesForm", false);


            let sourceType = "main";
            if (this.$route.path == "/LibraryManager/LibraryDetails") {
                sourceType = "details";
            }
            if (this.$route.path == "/PartManager/PartDetails") {
                sourceType = "details";
            }
            if (this.$route.path == "/ProjectManager/ProjectBom") {
                sourceType = "details";
            }

            
            let routingObject = {
                from: this.$route.path,
                to: to,
                revisionId: elementRevisionId,
                id: id,
                sourceType: sourceType, //"details"
                sourceId: this.projectId,
                sourceRevisionId: this.revisionId,
                end: false,
                selectedBomRow: this.$store.getters.selectedBomRow[0],
                bomId: this.$route.query.bomId
            }

            this.$store.commit("FORWARDROUTINGDATA", routingObject)

            

            this.$router.push({ path: to, query: routingObject });
        },
        buildContextMenu() {
           

            var _vue = this;

            //context-menu
            var tableid = $("#place" + this._uid);

            $("#place" + this._uid + " tbody tr")
                .on("contextmenu", function (e) {

                    let tr = $(this).closest('tr');
                    let row = _vue.mainTable.row(tr);

                    let data = row.data();

                    _vue.contextMenu.row = data


                    _vue.contextMenu.funcAction = function (_vue, action) {

                        //calling component methods depending on the context menu item clicked
                        if (action == "Details") {
                            //updateUser(data);
                            
                        }



                        return true;
                    }


                    var offsetX = tableid.offset().left;
                    var offsetY = tableid.offset().top;

                    var top = e.clientY - offsetY + 100;
                    var left = e.clientX - offsetX + 10;



                    $("#context-menu-" + _vue.id).css({
                        display: "block",
                        top: top,
                        left: left,

                    });

                    return false; //blocks default Webbrowser right click menu
                })
                .on("click", function () {

                    $("context-menu-" + _vue.id).hide();
                });

            $("#context-menu-" + _vue.id + " a").on("click", function () {

                $(this)
                    .parent()
                    .hide();
            });
            document.addEventListener('click', function (e) {
                let clickInside = e.target.closest("#context-menu-" + _vue.id);


                if (clickInside == null) {

                    let contextMenu = document.getElementById("context-menu-" + _vue.id);
                    if (contextMenu != null) {

                        contextMenu.setAttribute('style', 'display:none');
                    }

                }
            });
            //context-menu
        }

    }
}
</script>


<style lang="scss">
.UsedLibrariesInBomComponent {
    width: 100%;

    .dataTable {
        width: 100%;
    }

    table {
        font-size: 0.75rem;
        padding: 0px !important;
        width: 100%;
    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .dataTables_length {
        margin-left: 20px;
        width: 200px;
        float: left;
    }

    .dataTables_length label {
        display: inline-flex;
    }

    .select-length {
        padding: 0.1rem;
        margin-left: 10px;
        margin-right: 10px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        //margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
        width: 320px;
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .image {
        max-width: 40px;
        border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
    }

    .imageSVG {
        max-width: 40px;
        border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
        padding: 5px;
    }
    .badge{
        margin: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/UsedLibrariesInBomComponent.vue